import SpoferanRoutes from 'nuxt-spoferan/src/config/routes/spoferan';
import {parseRoute} from "nuxt-spoferan/src/helpers/parse_helpers";

export default ({$config, app}, inject) => {
    inject('spoferan', (name, params = {}) => {
        const locale = !app.i18n || app.i18n.locale === app.i18n.defaultLocale ? null : app.i18n.locale;

        return parseRoute(SpoferanRoutes, name, params, locale, $config.isSpoferanDomain ? false : $config.spoferanUrl)
    })
}